export default function createLayerNode(nodeName) {
    let layerContainerNode = document.querySelector(`[jsh-${nodeName}-layer]`);
    if (!layerContainerNode) {
        layerContainerNode = document.createElement('div');
        layerContainerNode.setAttribute(`jsh-${nodeName}-layer`, '');
        document.body.appendChild(layerContainerNode);
    }
    return layerContainerNode;
}
